// extracted by mini-css-extract-plugin
export default {"order-group-div-tr":"transaction-data_order-group-div-tr__s-MMV","order-group-div-hr":"transaction-data_order-group-div-hr__nF63E"};